// extracted by mini-css-extract-plugin
module.exports = {"rating":"qk","numberOfStars":"rk"};